import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
    extends: Bar,
    mixins: [reactiveProp],
    props: {
        chartData: {
            type: Object,
            default: null
        }
    },
    data: () => (
        {
            options: {
                responsive: false,
                maintainAspectRatio: false,
                elements: {
                    point: {
                        radius: 0
                    }
                },
                tooltips: {
                    mode: 'index',
                    callbacks: {
                        label: function(tooltipItems) {
                            if (!tooltipItems.yLabel) return 'N/A'
                            return `${(tooltipItems.yLabel * 100).toFixed()}%`;
                        }
                    },
                    yAlign: 'right',
                    xAlign: 'left'
                },
                scales : { 
                    xAxes: [{
                        stacked: true,
                        barPercentage: 0.7,
                        ticks: {
                            autoSkip: false,
                            maxRotation: 0,
                            fontFamily: 'Museo_Sans',
                            fontSize: 14
                        },
                        gridLines: {
                            display: false
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            callback: function(tick) {
                                return `${(tick * 100).toString()}%`
                            },
                            min: 0,
                            max: 1,
                            maxTicksLimit: 5,
                            fontFamily: 'Museo_Sans',
                            fontSize: 14,
                            stepSize: 0.25
                        },
                        gridLines: {
                            display: true,
                            color: '#979797'
                        },
                        scaleLabel: {
                            display: true,
                            fontSize: 20,
                            fontStyle: 'bold',
                            fontFamily: 'Museo_Sans'
                        }
                    },
                    {   
                        position: 'right',
                        ticks: {
                            display: false
                        },
                        gridLines: {
                            display: false,
                            color: '#979797'
                        },
                    }
                    ],
                },
                legend: {
                    display: false
                }
            },
        }
    ),   
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
}